var _rect, _line, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 179,
    viewBox: "0 0 216 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 179,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 30.5,
    x2: 216,
    y2: 30.5,
    stroke: "#E2E2E2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 119H17C15.3431 119 14 120.343 14 122V128C14 129.657 15.3431 131 17 131H23C24.6569 131 26 129.657 26 128V122C26 120.343 24.6569 119 23 119Z",
    fill: "#747776",
    stroke: "#747776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0701 122.375L23.0951 122.387C23.6071 122.622 23.6181 122.765 23.6251 122.892C23.6282 122.964 23.6165 123.036 23.5907 123.104C23.5649 123.171 23.5256 123.232 23.4751 123.284L19.4001 127.532L16.5361 125.305C16.4836 125.254 16.4422 125.193 16.4145 125.126C16.3868 125.058 16.3734 124.986 16.3752 124.913C16.3769 124.84 16.3939 124.768 16.4248 124.702C16.4558 124.636 16.5002 124.577 16.5551 124.529C16.6648 124.431 16.8079 124.379 16.9549 124.383C17.1019 124.388 17.2416 124.449 17.3451 124.553L19.0601 126.29L22.6501 122.548C23.0481 122.374 23.0581 122.375 23.0701 122.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 121H35.5C33.2909 121 31.5 122.791 31.5 125C31.5 127.209 33.2909 129 35.5 129H129.5C131.709 129 133.5 127.209 133.5 125C133.5 122.791 131.709 121 129.5 121Z",
    fill: "#747776"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 141.25H17.25C15.5931 141.25 14.25 142.593 14.25 144.25V149.75C14.25 151.407 15.5931 152.75 17.25 152.75H22.75C24.4069 152.75 25.75 151.407 25.75 149.75V144.25C25.75 142.593 24.4069 141.25 22.75 141.25Z",
    stroke: "#747776",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 143H35.5C33.2909 143 31.5 144.791 31.5 147C31.5 149.209 33.2909 151 35.5 151H102.5C104.709 151 106.5 149.209 106.5 147C106.5 144.791 104.709 143 102.5 143Z",
    fill: "#747776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempCheckbox);
export default __webpack_public_path__ + "static/media/temp-checkbox.ed326f160357ccf37dfaaf335cc056ef.svg";
export { ForwardRef as ReactComponent };